import { render, staticRenderFns } from "./SalesReport2.vue?vue&type=template&id=695e5745&"
import script from "./SalesReport2.vue?vue&type=script&lang=js&"
export * from "./SalesReport2.vue?vue&type=script&lang=js&"
import style0 from "./SalesReport2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports